import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Image, ImageFit } from '@fluentui/react/lib/Image';
import { DefaultButton, IButtonStyles } from '@fluentui/react/lib/Button';
import type AccountProviderInfo from '../store/schema/AccountProviderInfo';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import getSelectedAccountProvider from '../selectors/getSelectedAccountProvider';
import getAccountsEditorState from '../selectors/getAccountsEditorState';
import { AccountsEditorState } from '../store/schema/AccountsEditorState';

const styles = require('./AccountProvider.scss');

export interface AccountProviderProps {
    accountProviderInfo: AccountProviderInfo;
}

const AccountProvider: React.FunctionComponent<AccountProviderProps> = observer(
    function AccountProvider(props: AccountProviderProps) {
        const { label, icon } = props.accountProviderInfo;

        const onClick = React.useCallback(() => {
            props.accountProviderInfo.onClick(props.accountProviderInfo.accountProviderType);
        }, [props.accountProviderInfo.onClick, props.accountProviderInfo.accountProviderType]);

        let showSpinner =
            getSelectedAccountProvider() == props.accountProviderInfo.accountProviderType &&
            getAccountsEditorState() == AccountsEditorState.Adding;

        let isDisabled = getAccountsEditorState() == AccountsEditorState.Adding;

        return (
            <DefaultButton
                className={styles.button}
                styles={getColumnFlexContainerStyle()}
                onClick={onClick}
                disabled={isDisabled}>
                <div className={styles.imageContainer}>
                    <Image
                        className={styles.accountProviderIcon}
                        shouldFadeIn={false}
                        shouldStartVisible={true}
                        src={icon}
                        imageFit={ImageFit.contain}
                        alt={''} // Provide empty altText to hide images from screenreaders
                    />
                </div>
                <div className={styles.label} title={label}>
                    {label}
                </div>
                {showSpinner && (
                    <Spinner size={SpinnerSize.small} className={styles.accountAddingSpinner} />
                )}
            </DefaultButton>
        );
    }
);

export default AccountProvider;

function getColumnFlexContainerStyle(): IButtonStyles {
    return {
        flexContainer: {
            width: '100%',
            flexDirection: 'row',
            padding: 0,
            justifyContent: 'flex-start',
        },
    };
}
